(function () {
  if (window.__AG_PB_PD_ATC_INIT__) return;
  window.__AG_PB_PD_ATC_INIT__ = true;

  // The Eyr campaign engine adds the campaign's gifts after the cart changes. Going to checkout straight away
  // would leave the page before it has, so wait for its check (at most 4 seconds), then go.
  function agGoToCheckout() {
    var engine = window.EyrCampaignEngine;
    var go = function () { window.location.href = '/checkout'; };
    if (!engine || typeof engine.sync !== 'function') return go();
    var done = false;
    var once = function () { if (!done) { done = true; go(); } };
    setTimeout(once, 4000);
    try { Promise.resolve(engine.sync()).then(once, once); } catch (e) { once(); }
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  // ?type=otp — one-time-purchase-only landing pages carry no selling plan,
  // so the recurring-refill note (cadence + refill pricing) never applies.
  function isOtpMode() {
    try {
      return new URLSearchParams(location.search).get('type') === 'otp';
    } catch (e) {
      return false;
    }
  }

  function setText(el, value) {
    if (!el) return;
    el.textContent = value || '';
  }

  function toggleEmpty(el, value) {
    if (!el) return;
    var empty = !value;
    el.hidden = empty;
    el.classList.toggle('is-empty', empty);
  }

  function applyDetail(atc, detail) {
    if (!atc || !detail) return;
    if (detail.root && !detail.root.contains(atc)) return;

    var idInput = qs('input[name="id"]', atc);
    var spInput = qs('input[name="selling_plan"]', atc);
    var btn = qs('[data-ag-pb-pd-atc-btn]', atc);

    if (idInput && /^\d+$/.test(String(detail.variantId || ''))) {
      idInput.value = detail.variantId;
    }
    if (spInput) {
      spInput.value = /^\d+$/.test(String(detail.sellingPlan || '')) ? detail.sellingPlan : '';
    }

    var btnCompare = qs('[data-ag-pb-pd-btn-compare]', atc);
    var btnPrice = qs('[data-ag-pb-pd-btn-price]', atc);
    setText(btnCompare, detail.compareTotal);
    toggleEmpty(btnCompare, detail.compareTotal);
    setText(btnPrice, detail.priceTotal);

    var noteCompare = qs('[data-ag-pb-pd-note-compare]', atc);
    var notePrice = qs('[data-ag-pb-pd-note-price]', atc);
    var noteDays = qs('[data-ag-pb-pd-note-days]', atc);
    setText(noteCompare, detail.refillCompare || detail.compareTotal);
    toggleEmpty(noteCompare, detail.refillCompare || detail.compareTotal);
    setText(notePrice, detail.refillPrice);
    setText(noteDays, detail.refillDays);

    // The campaign's renewal line (printed per card on the server); hidden when the phase has none or on one-time.
    var renewal = qs('[data-ag-pb-pd-renewal]', atc);
    if (renewal) {
      renewal.textContent = detail.renewalLine || '';
      renewal.hidden = !detail.renewalLine || isOtpMode();
    }

    if (btn) {
      if (detail.available === false) {
        btn.disabled = true;
      } else if (btn.getAttribute('aria-busy') !== 'true') {
        btn.disabled = false;
      }
    }
  }

  function syncFromActiveCard(atc) {
    var details = atc.closest('[data-ag-pb-product-details]') || document;
    var card = qs('[data-ag-pb-pd-variant-card].is-active', details)
      || qs('[data-ag-pb-pd-variant-card]', details);
    if (!card) return;

    applyDetail(atc, {
      root: details,
      variantId: (card.getAttribute('data-variant-id') || '').trim(),
      sellingPlan: (card.getAttribute('data-selling-plan') || '').trim(),
      priceTotal: (card.getAttribute('data-price-total') || '').trim(),
      compareTotal: (card.getAttribute('data-compare-total') || '').trim(),
      refillPrice: (card.getAttribute('data-refill-price') || '').trim(),
      refillCompare: (card.getAttribute('data-refill-compare') || '').trim(),
      refillDays: (card.getAttribute('data-refill-days') || '').trim(),
      renewalLine: (card.getAttribute('data-renewal-line') || '').trim(),
      available: !card.disabled
    });
  }

  function openMiniCart(cartData) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cartData, openMiniCart: true }
    }));

    var cartDrawer = document.querySelector('cart-drawer, #mini-cart');
    if (cartDrawer) {
      cartDrawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    if (typeof updateCartItemCount === 'function') {
      updateCartItemCount();
    }

    document.dispatchEvent(new CustomEvent('cart:changed', { bubbles: true }));
  }

  function initAtc(atc) {
    if (!atc || atc.dataset.agPbPdAtcReady === 'true') return;
    atc.dataset.agPbPdAtcReady = 'true';

    if (isOtpMode()) {
      var refill = qs('[data-ag-pb-pd-atc-refill]', atc);
      if (refill) refill.hidden = true;
    }

    syncFromActiveCard(atc);

    var form = qs('form[data-ag-pb-pd-atc-form]', atc);
    if (!form) return;

    var mode = (form.getAttribute('data-cta-mode') || 'cart').toLowerCase();
    var inflight = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (inflight) return;

      syncFromActiveCard(atc);

      var idInput = qs('input[name="id"]', form);
      var spInput = qs('input[name="selling_plan"]', form);
      var variantId = idInput ? String(idInput.value || '').trim() : '';
      var spRaw = spInput ? String(spInput.value || '').trim() : '';

      if (!/^\d+$/.test(variantId)) {
        console.error('[AG PD ATC] Missing/invalid variant id');
        return;
      }

      var item = { id: Number(variantId), quantity: 1 };
      if (/^\d+$/.test(spRaw)) item.selling_plan = Number(spRaw);

      var btn = qs('[data-ag-pb-pd-atc-btn]', atc);
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      inflight = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw body;
            return body;
          });
        })
        .then(function (addBody) {
          if (mode === 'checkout') {
            agGoToCheckout();
            return;
          }

          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              openMiniCart(cart || addBody);
            })
            .catch(function () {
              openMiniCart(addBody);
            });
        })
        .catch(function (err) {
          console.error('[AG PD ATC ERROR]', err);
        })
        .finally(function () {
          inflight = false;
          if (btn && mode !== 'checkout') {
            btn.removeAttribute('aria-busy');
            syncFromActiveCard(atc);
          }
        });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    qsa('[data-ag-pb-pd-atc]', root).forEach(initAtc);
    if (root.matches && root.matches('[data-ag-pb-pd-atc]')) initAtc(root);
  }

  document.addEventListener('ag-pb-pd:variant-change', function (e) {
    var detail = e.detail || {};
    var root = detail.root || document;
    qsa('[data-ag-pb-pd-atc]', root).forEach(function (atc) {
      applyDetail(atc, detail);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
